import { Constants } from "./constants";

/**
 * Determines the number of searches required for a given scentwork element and level.
 * 
 * Rules:
 * - Master Interior: 3 searches
 * - Master Exterior/Buried/Container: 1 search
 * - Excellent Interior: 2 searches
 * - All other levels: 1 search
 */
export const getScentworkNumSearches = (element: string, level: string): number => {
  // Master level logic
  if (level === Constants.dog_class_element_level.master || 
      level === Constants.dog_class_element_level.scentwork_master) {
    if (element === Constants.dog_class_element.scentwork_interior) {
      return 3; // Master Interior = 3 searches
    }
    return 1; // Master Exterior/Buried/Container = 1 search
  }
  
  // Excellent level logic
  if (level === Constants.dog_class_element_level.excellent ||
      level === Constants.dog_class_element_level.scentwork_excellent) {
    if (element === Constants.dog_class_element.scentwork_interior) {
      return 2; // Excellent Interior = 2 searches
    }
  }
  
  // All other levels default to 1 search
  return 1;
};

